import { faTachometerAltSlow } from '@fortawesome/pro-regular-svg-icons/faTachometerAltSlow'
import { faShoppingBasket } from '@fortawesome/pro-regular-svg-icons/faShoppingBasket'
import { faBoxFull } from '@fortawesome/pro-regular-svg-icons/faBoxFull'
import { faTags } from '@fortawesome/pro-regular-svg-icons/faTags'
import { faBrowser } from '@fortawesome/pro-regular-svg-icons/faBrowser'
import { faMapPin } from '@fortawesome/pro-regular-svg-icons/faMapPin'
import { faUsers } from '@fortawesome/pro-regular-svg-icons/faUsers'
import { faSlidersH } from '@fortawesome/pro-regular-svg-icons/faSlidersH'

const ROLE_ADMIN = 'ROLE_ADMIN'

export default {
    dashboard: {
        label: 'Dashboard',
        icon: faTachometerAltSlow,
        path: '/',
        sortOrder: 10,
        roles: [ROLE_ADMIN],
    },
    orders: {
        label: 'Orders',
        icon: faShoppingBasket,
        path: '/orders',
        sortOrder: 20,
        roles: [ROLE_ADMIN],
    },
    products: {
        label: 'Products',
        icon: faBoxFull,
        sortOrder: 30,
        roles: [ROLE_ADMIN],
        children: {
            allProducts: {
                label: 'All Products',
                path: '/products',
                sortOrder: 10,
                roles: [ROLE_ADMIN],
            },
            productVariants: {
                label: 'Product Variants',
                path: '/variants',
                sortOrder: 20,
                roles: [ROLE_ADMIN],
                feature: 'products.productVariants',
            },
            categories: {
                label: 'Categories',
                path: '/categories',
                sortOrder: 30,
                roles: [ROLE_ADMIN],
            },
            attributes: {
                label: 'Attributes',
                sortOrder: 40,
                roles: [ROLE_ADMIN],
                children: {
                    allAttributes: {
                        label: 'All Attributes',
                        path: '/attributes',
                        sortOrder: 10,
                        roles: [ROLE_ADMIN],
                    },
                    attributeGroups: {
                        label: 'Attribute Groups',
                        path: '/attribute-groups',
                        sortOrder: 20,
                        roles: [ROLE_ADMIN],
                    },
                    attributeSets: {
                        label: 'Attribute Sets',
                        path: '/attribute-sets',
                        sortOrder: 30,
                        roles: [ROLE_ADMIN],
                    },
                },
            },
        },
    },
    promotions: {
        label: 'Promotions',
        icon: faTags,
        path: '/promotions',
        sortOrder: 40,
        roles: [ROLE_ADMIN],
    },
    content: {
        label: 'Content',
        icon: faBrowser,
        sortOrder: 50,
        roles: [ROLE_ADMIN],
        children: {
            pages: {
                label: 'Pages',
                path: '/pages',
                sortOrder: 10,
                roles: [ROLE_ADMIN],
            },
            articles: {
                label: 'Articles',
                path: '/articles',
                sortOrder: 20,
                roles: [ROLE_ADMIN],
            },
            articleCategories: {
                label: 'Article Categories',
                path: '/article-categories',
                sortOrder: 30,
                roles: [ROLE_ADMIN],
            },
            templates: {
                label: 'Templates',
                path: '/templates',
                sortOrder: 40,
                roles: [ROLE_ADMIN],
            },
            elements: {
                label: 'Elements',
                path: '/elements',
                sortOrder: 50,
                roles: [ROLE_ADMIN],
            },
            elementAreas: {
                label: 'Element Areas',
                path: '/element-areas',
                sortOrder: 60,
                roles: [ROLE_ADMIN],
            },
            forms: {
                label: 'Forms',
                icon: 'map-pin',
                sortOrder: 70,
                roles: [ROLE_ADMIN],
                children: {
                    allForms: {
                        label: 'All Forms',
                        path: '/forms',
                        sortOrder: 10,
                        roles: [ROLE_ADMIN],
                    },
                    formFields: {
                        label: 'Form Fields',
                        path: '/form-fields',
                        sortOrder: 20,
                        roles: [ROLE_ADMIN],
                    },
                    formSubmissions: {
                        label: 'Form Submissions',
                        path: '/form-submissions',
                        sortOrder: 30,
                        roles: [ROLE_ADMIN],
                    },
                },
            },
        },
    },
    locations: {
        label: 'Locations',
        icon: faMapPin,
        path: '/locations',
        sortOrder: 60,
        roles: [ROLE_ADMIN],
    },
    users: {
        label: 'Users',
        icon: faUsers,
        sortOrder: 70,
        roles: [ROLE_ADMIN],
        children: {
            allUsers: {
                label: 'All Users',
                path: '/users',
                sortOrder: 10,
                roles: [ROLE_ADMIN],
            },
            userGroups: {
                label: 'User Groups',
                path: '/user-groups',
                sortOrder: 20,
                roles: [ROLE_ADMIN],
                feature: 'user.userGroups',
            },
        },
    },
    configuration: {
        label: 'Configuration',
        icon: faSlidersH,
        sortOrder: 80,
        roles: [ROLE_ADMIN],
        children: {
            settings: {
                label: 'Settings',
                path: '/settings',
                sortOrder: 10,
                roles: [ROLE_ADMIN],
            },
            navigation: {
                label: 'Navigation',
                path: '/menus',
                sortOrder: 20,
                roles: [ROLE_ADMIN],
            },
            redirects: {
                label: 'Redirects',
                path: '/redirects',
                sortOrder: 30,
                roles: [ROLE_ADMIN],
            },
            shippingServices: {
                label: 'Shipping Services',
                path: '/shipping-services',
                sortOrder: 40,
                roles: [ROLE_ADMIN],
            },
            tasks: {
                label: 'Tasks',
                path: '/tasks',
                sortOrder: 50,
                roles: [ROLE_ADMIN],
            },
            countries: {
                label: 'Countries',
                path: '/countries',
                sortOrder: 60,
                roles: [ROLE_ADMIN],
            },
        },
    },
}
